module.exports = __webpack_public_path__ + "static/media/chi.dd49bb98.png";